import type { WinDivisions } from '../../../../../schema/forecast/entry.js';

/**
 * Calculate the player's and group's win amount based on win divisions, bet amount, and share counts.
 *
 * @param root0 Object containing win divisions, bet amount, share counts, and optional win divisions row count
 * @param root0.winDivisions Current win divisions for draw
 * @param root0.betAmount Bet amount for the wager
 * @param root0.winDivisionsRowCount Array of number of rows in each win division
 * @param root0.customerShareCount Number of shares the customer holds
 * @param root0.totalShareCount Total number of shares in the group
 * @returns Calculated player and group win amounts
 */
export function calculateGroupWinAmounts({
  winDivisions,
  winDivisionsRowCount,
  customerShareCount,
  totalShareCount,
  betAmount,
}: {
  winDivisions: WinDivisions[];
  winDivisionsRowCount?: number[];
  customerShareCount?: number;
  totalShareCount?: number;
  betAmount: number;
}): { groupWinAmount: number; playerWinAmount: number } {
  let groupWinAmount = 0;
  let playerWinAmount = 0;

  if (!Array.isArray(winDivisions) || !Array.isArray(winDivisionsRowCount)) {
    return {
      groupWinAmount,
      playerWinAmount,
    };
  }

  for (const { winDivision, winValue } of winDivisions) {
    const winDivisionWinValue = (winDivisionsRowCount[winDivision - 1] ?? 0) * winValue * betAmount;
    const winDivisionShareValue = winDivisionWinValue / (totalShareCount ?? 1);
    playerWinAmount += winDivisionShareValue * (customerShareCount ?? 0);
    groupWinAmount += winDivisionShareValue * (totalShareCount ?? 0);
  }

  return {
    groupWinAmount: groupWinAmount,
    playerWinAmount: playerWinAmount,
  };
}
